// extracted by mini-css-extract-plugin
export var wordContainer = "_sa-0";